// Make sure this value is applied across all Discourse API calls
export const RESULTS_PER_PAGE = 30;
